import { c as _c } from "react/compiler-runtime";
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { NavLevel } from '../../molecules/nav-stack/nav-stack.tsx';
import { NavStack } from '../../molecules/nav-stack/nav-stack.tsx';
type MobileMenuProps = {
  navStack: NavLevel[];
  setNavStack: React.Dispatch<React.SetStateAction<NavLevel[]>>;
  onClose: () => void;
  onBack: () => void;
  mobileCloseButtonRef: React.RefObject<HTMLButtonElement | null>;
  mobileOpenButtonRef: React.RefObject<HTMLButtonElement | null>;
  showLogin?: boolean;
  children: React.ReactNode;
};
export const MobileMenu: React.FC<MobileMenuProps> = t0 => {
  const $ = _c(29);
  const {
    navStack,
    setNavStack,
    onClose,
    onBack,
    mobileCloseButtonRef,
    mobileOpenButtonRef,
    showLogin,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const t2 = navStack.length === 1;
  const t3 = navStack.length > 1;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cn("Header__mobile-nav flex px-comfy-xs py-comfy-lg items-center", {
      "justify-end": t2,
      "justify-between": t3
    });
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== mobileOpenButtonRef || $[5] !== navStack.length || $[6] !== onBack) {
    t5 = Boolean(navStack.length > 1) && <button ref={mobileOpenButtonRef} className="flex items-center" type="button" onClick={onBack}><ArkIcon iconName="arrow-left" className="Header__nav-icon" /></button>;
    $[4] = mobileOpenButtonRef;
    $[5] = navStack.length;
    $[6] = onBack;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("header.menu");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArkIcon iconName="x-close" className="Header__nav-icon" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== mobileCloseButtonRef || $[12] !== onClose || $[13] !== t6) {
    t8 = <button ref={mobileCloseButtonRef} className="Header__nav-action flex items-center p-comfy-xs" type="button" title={t6} onClick={onClose}>{t7}</button>;
    $[11] = mobileCloseButtonRef;
    $[12] = onClose;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== children || $[16] !== t8) {
    t9 = <span className="flex items-center gap-snug-md md:gap-snug-xl lg:gap-comfy-sm">{children}{t8}</span>;
    $[15] = children;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== navStack || $[23] !== setNavStack || $[24] !== showLogin) {
    t11 = <NavStack stack={navStack} setStack={setNavStack} showMyAccountSection={showLogin} className="pb-roomy-sm" />;
    $[22] = navStack;
    $[23] = setNavStack;
    $[24] = showLogin;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <NavigationMenu.Content className="Header__content Header__content--mobile flex flex-col" onPointerLeave={_temp}>{t10}{t11}</NavigationMenu.Content>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(e) {
  return e.preventDefault();
}